import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'

/**
 * Multiple subscriptions per customer switch component
 * Handles multiple subscriptions setting using React Hook Form with Controller
 */
export const MultipleSubscriptionsSwitch = () => {
    const { t } = useTranslation(['stores', 'common'])
    const { control } = useFormContext<{ multipleSubscriptionsPerCustomerEnabled: boolean }>()

    return (
        <div className="flex items-center justify-between">
            <div className="space-y-1">
                <Label>
                    {t('form.multipleSubscriptions')}
                </Label>
                <p className="text-xs text-gray-500">
                    {t('form.multipleSubscriptionsDescription')}
                </p>
            </div>
            <Controller
                name="multipleSubscriptionsPerCustomerEnabled"
                control={control}
                render={({ field: { value, onChange } }) => (
                    <Switch checked={value} onCheckedChange={onChange} />
                )}
            />
        </div>
    )
}

